import { Settings2 } from 'lucide-react';
import { Button } from '../../ui/button';
import { Card, CardContent } from '../../ui/card';
import { CPTConfigValue } from '../../../services/api/CPTAnalytics/CPTConfigService';
import CPTSummarySection from './CPTSummarySection';
import CPTDetailedReportSection from './CPTDetailedReportSection';
import CPTMonthlyOverviewSection from './CPTMonthlyOverviewSection';

interface CPTAnalyticsTabProps {
    config: CPTConfigValue | null;
    loadingConfig?: boolean;
    onGoToConfig?: () => void;
}

export default function CPTAnalyticsTab({ config, loadingConfig, onGoToConfig }: CPTAnalyticsTabProps) {
    return (
        <div className="mt-6 space-y-10">
            {!loadingConfig && config && !config.createdAt && (
                <Card className="border border-blue-500/30 bg-blue-500/10">
                    <CardContent className="flex items-start gap-4 p-5">
                        <div className="rounded-lg bg-blue-500/20 p-2">
                            <Settings2 className="h-5 w-5 text-blue-400" aria-hidden="true" />
                        </div>
                        <div className="flex-1 space-y-1">
                            <p className="text-sm font-medium text-foreground">
                                Configuration required
                            </p>
                            <p className="text-sm text-muted-foreground">
                                Configure your CPT code RVU weights and reimbursement rates to enable revenue tracking and reporting. Optionally set monthly estimates to track department performance.
                            </p>
                        </div>
                        {onGoToConfig && (
                            <Button variant="outline" size="sm" className="shrink-0 mt-1" onClick={onGoToConfig}>
                                Go to Config
                            </Button>
                        )}
                    </CardContent>
                </Card>
            )}

            <CPTSummarySection config={config} />

            <CPTDetailedReportSection />

            <CPTMonthlyOverviewSection />
        </div>
    );
}
